import React, { useEffect, useState } from "react";
import { Backdrop, Fade, Modal } from "@material-ui/core";
import {
  CallMade,
  Close,
  DescriptionOutlined,
  SchoolOutlined,
} from "@material-ui/icons";
import "./StudentLoginModal.css";

const STUDENT_LOGIN_URL = "https://my.nti.edu.ng/student/login";

const PORTALS = [
  { name: "Degree Portal", url: "https://nti.safsrms.com" },
  { name: "Diploma Portal", url: "https://nti_diploma.safsrms.com" },
  { name: "NCE Portal", url: "https://nti_nce.safsrms.com" },
];

const StudentLoginModal = ({ open, onClose }) => {
  const [tab, setTab] = useState("returning");

  // Always reopen on the "Returning students" tab
  useEffect(() => {
    if (open) setTab("returning");
  }, [open]);

  const isNew = tab === "new";

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 300, className: "slm-backdrop" }}
      aria-labelledby="student-login-title"
    >
      <Fade in={open} timeout={300}>
        <div className="slm-wrapper">
          <div className="slm-card">
            <button
              type="button"
              className="slm-close"
              onClick={onClose}
              aria-label="Close"
            >
              <Close />
            </button>

            <h2 id="student-login-title" className="slm-title">
              Student login
            </h2>
            <p className="slm-subtitle">
              Choose your student category to continue
            </p>

            <div className="slm-tabs" role="tablist">
              <span
                className={`slm-tab-indicator ${isNew ? "is-right" : ""}`}
                aria-hidden="true"
              />
              <button
                type="button"
                role="tab"
                aria-selected={!isNew}
                className={`slm-tab ${!isNew ? "slm-tab-active" : ""}`}
                onClick={() => setTab("returning")}
              >
                Returning students
              </button>
              <button
                type="button"
                role="tab"
                aria-selected={isNew}
                className={`slm-tab ${isNew ? "slm-tab-active" : ""}`}
                onClick={() => setTab("new")}
              >
                New students
              </button>
            </div>

            <div className="slm-panel" key={tab}>
              {!isNew ? (
                <>
                  <div className="slm-icon">
                    <SchoolOutlined />
                  </div>
                  <h3 className="slm-heading">Welcome back</h3>
                  <p className="slm-text">
                    Access your student account with your existing student
                    login details to continue your studies
                  </p>
                  <a href={STUDENT_LOGIN_URL} className="slm-primary-btn">
                    Login to student portal
                  </a>
                </>
              ) : (
                <>
                  <div className="slm-icon">
                    <DescriptionOutlined />
                  </div>
                  <h3 className="slm-heading">Welcome</h3>
                  <p className="slm-text">
                    Continue to your registration portal
                  </p>
                  <div className="slm-portal-list">
                    {PORTALS.map((portal, i) => (
                      <a
                        key={portal.name}
                        href={portal.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="slm-portal"
                        style={{ animationDelay: `${i * 60}ms` }}
                      >
                        <DescriptionOutlined className="slm-portal-doc" />
                        <span className="slm-portal-text">
                          <strong>{portal.name}</strong>
                          <span>Start or continue registration</span>
                        </span>
                        <CallMade className="slm-portal-arrow" />
                      </a>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default StudentLoginModal;
